module.exports = {
    updateNewRelicStatusAttributes: function (errorTitle, errorCause, errorMessage) {
        newrelic.setCustomAttribute("ESA_BFF_ERRORS", JSON.stringify({
            title: errorTitle,
            message: errorMessage,
            errorCauses: errorCause
        }));
        return errorCause;
    }
} 


// WEBPACK FOOTER //
// ./src/actions/NewRelicModule.js